import * as React from 'react'

import { Box, CollapsableCard, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import AttendanceSettingForm from 'modules/attendance/lib/forms/AttendanceSettingForm'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import useUpdateAttendanceSetting from '../hooks/useUpdateAttendanceSetting'

interface Props {
  attendanceSetting: AttendanceSetting
}

const createSettingForm = (setting: AttendanceSetting) =>
  new AttendanceSettingForm({
    missing_clock_in_alert: setting.attributes.missing_clock_in_alert,
  })

const MissingClockIn = ({ attendanceSetting }: Props) => {
  const [settingForm, setSettingForm] = React.useState(createSettingForm(attendanceSetting))
  const missingClockInAlertField = settingForm.get('missing_clock_in_alert')
  const { updateSetting } = useUpdateAttendanceSetting(settingForm, attendanceSetting)

  useEffect(() => {
    setSettingForm(createSettingForm(attendanceSetting))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attendanceSetting.attributes.id])

  const onChange = (newValue: boolean) => {
    track(trackingEvents.timeTracking.toggleMissingClockInAlert, {
      toggle_enabled: newValue,
    })
    missingClockInAlertField.set(newValue)
    updateSetting()
  }

  return (
    <CollapsableCard
      open={false}
      Card={
        <Box
          gap="s8"
          extra={{ 'data-intercom-target': 'attendance-timesheet-missing-clock-in-alert' }}
        >
          <Box flexDirection="row" justifyContent="spaceBetween">
            <Text.Normal weight="medium">
              {i18n.t('time_tracking.settings.missing_clock_in_inconsistencies.action')}
            </Text.Normal>
            <TogglerCheckbox
              value={missingClockInAlertField.value}
              onChange={(newValue) => onChange(newValue)}
              labelBefore
            />
          </Box>
          <Text.Normal>
            {i18n.t('time_tracking.settings.missing_clock_in_inconsistencies.description')}
          </Text.Normal>
        </Box>
      }
      Content={<></>}
    />
  )
}

export default observer(MissingClockIn)
